import { observer } from 'mobx-react-lite';

import { XStack, YStack } from '@/components/ui/layout/layout';
import { cn } from '@/lib/utils';

import { ckDebugStore } from '../ck-debug.store';

function MetricCard({
  label,
  value,
  secondary,
  valueClassName,
}: {
  label: string;
  value: string;
  secondary?: string;
  valueClassName?: string;
}) {
  return (
    <YStack className="flex-1 min-w-[140px] rounded-lg border border-border bg-surface px-3 py-2 gap-0.5">
      <span className="text-xs text-foreground-muted font-medium uppercase tracking-wide">
        {label}
      </span>
      <span
        className={cn(
          'text-xl font-mono font-semibold tabular-nums text-foreground',
          valueClassName
        )}
      >
        {value}
      </span>
      {secondary && (
        <span className="text-xs text-foreground-subtle font-mono tabular-nums">
          {secondary}
        </span>
      )}
    </YStack>
  );
}

export const CkDebugMetricCards = observer(() => {
  const m = ckDebugStore.aggregateMetrics;

  const successRateColor =
    m.successRate > 95
      ? 'text-success-11'
      : m.successRate > 80
        ? 'text-warning-11'
        : m.totalSnapshots === 0
          ? ''
          : 'text-danger-11';

  return (
    <XStack className="px-3 py-2 gap-2 border-b border-border shrink-0">
      <MetricCard
        label="Snapshots/min"
        value={String(m.snapshotsPerMinute)}
        secondary={`${m.failedCount} failed`}
      />
      <MetricCard
        label="Snapshots w/ Dedup"
        value={`${m.dedupRate}%`}
        secondary={`${m.dedupedSnapshotCount} snapshots, ${m.totalTraversedDedup + m.totalParsedDedup + m.totalScreenshotDedup} items`}
      />
      <MetricCard
        label="Success Rate"
        value={m.totalSnapshots > 0 ? `${m.successRate}%` : '-'}
        secondary={`${m.totalSnapshots} total`}
        valueClassName={successRateColor}
      />
      <MetricCard
        label="Avg Duration"
        value={m.totalSnapshots > 0 ? `${m.avgDurationMs}ms` : '-'}
      />
    </XStack>
  );
});
